import {
  Button as TitleTypography,
  useThemeContext,
} from '@huggg/react-components';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { getHugggTitle } from '../../utilities/huggg';
import HugggImage from './HugggImage';
import styles from './huggg.module.scss';

const renderTextFields = (title, description) => (
  <>
    {title && (
      <TitleTypography className={classnames(styles.title)}>
        {title}
      </TitleTypography>
    )}
    {description && (
      <div className={classnames(styles.description)}>{description}</div>
    )}
  </>
);

const Huggg = (props) => {
  const { operator } = useThemeContext();
  const {
    huggg,
    hideImage,
    hideDescription,
    imageOverride,
    titleOverride,
    descriptionOverride,
  } = props;

  const title = titleOverride || getHugggTitle(huggg);
  const description = !hideDescription
    ? descriptionOverride ||
      huggg?.meta?.customDescription ||
      huggg?.purchase?.merchandising_title
    : null;

  const isOOS = Boolean(huggg?.purchase?.out_of_stock);
  const isOOSMessage = huggg?.purchase?.out_of_stock_message || '';
  const isMoreDetails = window.location.pathname.includes('more-information');

  return (
    <div className={styles.huggg}>
      {isOOS && isMoreDetails && (
        <div className={styles.overlay}>
          <div className={styles.overlayContent}>
            <TitleTypography className={styles.overlayMessage}>
              Temporarily out of stock
            </TitleTypography>
            {isOOSMessage && (
              <div className={styles.overlayDescription}>{isOOSMessage}</div>
            )}
            <div className={styles.overlayDescription}>
              {operator.showHugggSupportLinks
                ? 'We are sorry for the inconvenience. To claim an alternative gift, please email hello@huggg.me'
                : operator.support}
            </div>
          </div>
        </div>
      )}
      {!hideImage && (
        <div>
          <HugggImage huggg={huggg} imageOverride={imageOverride} />
        </div>
      )}
      {renderTextFields(title, description)}
    </div>
  );
};

Huggg.propTypes = {
  huggg: PropTypes.object.isRequired,
  hideImage: PropTypes.bool,
  imageOverride: PropTypes.string,
  titleOverride: PropTypes.string,
  descriptionOverride: PropTypes.string,
  hideDescription: PropTypes.bool,
};

export default Huggg;
